var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-upload-questions"},[_c('h2',{staticClass:"section--title"},[_vm._v(_vm._s(_vm.question.label))]),_c('div',{staticClass:"question-list"},[_c('image-upload',{on:{"handleSelect":_vm.handleSelect}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }